/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientProviderStatus } from './RecipientProviderStatus';
import {
    RecipientProviderStatusFromJSON,
    RecipientProviderStatusFromJSONTyped,
    RecipientProviderStatusToJSON,
    RecipientProviderStatusToJSONTyped,
} from './RecipientProviderStatus';
import type { RecipientResolutionCandidate } from './RecipientResolutionCandidate';
import {
    RecipientResolutionCandidateFromJSON,
    RecipientResolutionCandidateFromJSONTyped,
    RecipientResolutionCandidateToJSON,
    RecipientResolutionCandidateToJSONTyped,
} from './RecipientResolutionCandidate';

/**
 * 
 * @export
 * @interface ReferralRecipientConfig
 */
export interface ReferralRecipientConfig {
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    sender_facility_id: number;
    /**
     * 
     */
    provider_id?: string;
    /**
     * 
     */
    provider_type?: string;
    /**
     * 
     */
    provider_name: string;
    /**
     * True when the recipient's provider is an external (non-ExaCare) directory row, or when it's an "other" recipient. External recipients require an email address; fax is optional.
     */
    is_external: boolean;
    /**
     * 
     */
    address?: string;
    /**
     * 
     */
    display_name?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    notes?: string;
    /**
     * 
     */
    provider_status?: RecipientProviderStatus;
    /**
     * 
     */
    ccn?: string;
    /**
     * 
     */
    resolution_candidates?: Array<RecipientResolutionCandidate>;
    /**
     * 
     */
    contact_id?: string;
    /**
     * 
     */
    contact_name?: string;
    /**
     * 
     */
    contact_email?: string;
    /**
     * 
     */
    contact_phone?: string;
    /**
     * Fax number to deliver referrals to via eFax, in addition to or instead of email.
     */
    fax?: string;
}



/**
 * Check if a given object implements the ReferralRecipientConfig interface.
 */
export function instanceOfReferralRecipientConfig(value: object): value is ReferralRecipientConfig {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('provider_name' in value) || value['provider_name'] === undefined) return false;
    if (!('is_external' in value) || value['is_external'] === undefined) return false;
    return true;
}

export function ReferralRecipientConfigFromJSON(json: any): ReferralRecipientConfig {
    return ReferralRecipientConfigFromJSONTyped(json, false);
}

export function ReferralRecipientConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRecipientConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sender_facility_id': json['sender_facility_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'provider_type': json['provider_type'] == null ? undefined : json['provider_type'],
        'provider_name': json['provider_name'],
        'is_external': json['is_external'],
        'address': json['address'] == null ? undefined : json['address'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'provider_status': json['provider_status'] == null ? undefined : RecipientProviderStatusFromJSON(json['provider_status']),
        'ccn': json['ccn'] == null ? undefined : json['ccn'],
        'resolution_candidates': json['resolution_candidates'] == null ? undefined : ((json['resolution_candidates'] as Array<any>).map(RecipientResolutionCandidateFromJSON)),
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'contact_name': json['contact_name'] == null ? undefined : json['contact_name'],
        'contact_email': json['contact_email'] == null ? undefined : json['contact_email'],
        'contact_phone': json['contact_phone'] == null ? undefined : json['contact_phone'],
        'fax': json['fax'] == null ? undefined : json['fax'],
    };
}

export function ReferralRecipientConfigToJSON(json: any): ReferralRecipientConfig {
    return ReferralRecipientConfigToJSONTyped(json, false);
}

export function ReferralRecipientConfigToJSONTyped(value?: ReferralRecipientConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sender_facility_id': value['sender_facility_id'],
        'provider_id': value['provider_id'],
        'provider_type': value['provider_type'],
        'provider_name': value['provider_name'],
        'is_external': value['is_external'],
        'address': value['address'],
        'display_name': value['display_name'],
        'email': value['email'],
        'phone': value['phone'],
        'notes': value['notes'],
        'provider_status': RecipientProviderStatusToJSON(value['provider_status']),
        'ccn': value['ccn'],
        'resolution_candidates': value['resolution_candidates'] == null ? undefined : ((value['resolution_candidates'] as Array<any>).map(RecipientResolutionCandidateToJSON)),
        'contact_id': value['contact_id'],
        'contact_name': value['contact_name'],
        'contact_email': value['contact_email'],
        'contact_phone': value['contact_phone'],
        'fax': value['fax'],
    };
}

